import { Button, Skeleton, Table } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCategories } from "../../actions/categories";
import { formatDate } from "../../utils/Utils";

const Categories = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const history = useNavigate();
  const data = useSelector((state) => state.categories);

  useEffect(() => {
    setLoading(true);
    dispatch(getCategories(currentUser.store));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Category",
      render: (_, record) => record?.name,
    },
    {
      key: 2,
      title: "Updated At",
      render: (_, record) => <p>{formatDate(record?.updatedAt)}</p>,
    },
    {
      key: 3,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  const onRowClick = (id) => {
    history(`/category/${id}`);
  };

  return (
    <Dashboard title="Categories">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">Categories</h2>
        <Button type="primary" href="/category/new" htmlType="submit">
          Add Category
        </Button>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1000,
            }}
            rowKey={(record) => record?._id}
            onRow={(record) => {
              return {
                onClick: () => {
                  onRowClick(record?._id);
                },
              };
            }}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Categories;
